import { type Product } from '@/domain/Product';
import useTranslations from '@/widgets/hooks/useTranslations.tsx';
import type { Translations } from '@/widgets/ProductList/config/index.ts';
import CapsuleQuickViewContent from '../parts/CapsuleQuickViewContent/CapsuleQuickViewContent.tsx';
import QuickViewFooter from '../parts/QuickViewFooter/QuickViewFooter.tsx';
import ModalOnDemand from '@/widgets/components/controls/ModalOnDemand/ModalOnDemand.tsx';

export type CapsuleQuickViewDrawerProps = {
  product?: Product;
  isOpen: boolean;
  onClose: () => void;
  onGoToProductPage: (event: MouseEvent) => void;
};

export default function CapsuleQuickViewDrawer({
  product,
  isOpen,
  onClose,
  onGoToProductPage
}: CapsuleQuickViewDrawerProps) {
  if (!product) return null;

  const { t } = useTranslations<Translations>();
  const closeBtnA11yLabel = t('components.modal.closeBtnA11yLabel');
  const pdpLinkText = t('productList.quickView.seeDetailsLinkLabel');

  return (
    <ModalOnDemand
      closeBtnA11yLabel={closeBtnA11yLabel}
      position="side"
      isOpen={isOpen}
      isMediaModal
      onClose={onClose}
      fixedFooter
      footerSlot={
        <QuickViewFooter
          product={product}
          onGoToProductPage={onGoToProductPage}
        />
      }
    >
      <CapsuleQuickViewContent
        product={product}
        pdpLinkText={pdpLinkText}
        onGoToProductPage={onGoToProductPage}
      />
    </ModalOnDemand>
  );
}
